
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ReasonModel } from './Entities.GormCrm.Reason';
import { Model, ModelProperty } from 'models/Model';


export class ReasonCategoryModel extends Model<ReasonCategoryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'reasons', type: 'ReasonModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public created?: Date;
	public reasons: ReasonModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.reasons = [];
		
	}
	getProperties(){
		return ReasonCategoryModel.classProperties;
	}
}

